module.exports = __webpack_public_path__ + "img/qr-google.5919d46e.png";